import React from "react";
import Logo from "./Logo";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#04070D] border-t border-[#1E2A3B]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo size="lg" />
            <p className="mt-6 text-sm text-[#94A3B8] leading-relaxed max-w-md">
              Professional project scheduling and project controls consulting —
              built for construction, infrastructure, and engineering teams that
              demand clarity, control, and confidence.
            </p>
          </div>
          <div>
            <div className="font-mono-accent text-[10px] text-[#4A6E8C] mb-4">
              / Services
            </div>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li>Project Scheduling</li>
              <li>Critical Path Analysis</li>
              <li>Schedule Recovery</li>
              <li>Project Controls Support</li>
            </ul>
          </div>
          <div>
            <div className="font-mono-accent text-[10px] text-[#4A6E8C] mb-4">
              / Contact
            </div>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li>support@bluelinecontrolsystems.com</li>
              <li>Nationwide / Remote-first</li>
              <li>Mon–Fri · 8:00 – 18:00</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#1E2A3B] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="font-mono-accent text-[10px] text-[#4A6E8C]">
            © {year} BlueLine Control Systems LLC · All rights reserved
          </div>
          <div className="font-mono-accent text-[10px] text-[#4A6E8C] flex items-center gap-3">
            <span className="w-1.5 h-1.5 bg-[#00E5FF] inline-block animate-pulse" />
            System online · BLN-CS / v1.0
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
